import axios from "axios";

async function verifyLogin(email) {
  let _token = await getToken();
  var options = {
    url: "https://hall-gateway.inteegra.com.br/hall/api/event/guest/login",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "bearer " + _token,
    },
    data: {
      type: 2,
      text: email,
      eventId: 83778,
      password: null,
    },
  };

  return axios(options)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

const getToken = async () => {
  return new Promise((resolve, reject) => {
    resolve(
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6IkJjWkJxbmV4QlQzeTFSTVZaT042RmtsL0pna1JXbU8yeExPdEtGM21sQXc9IiwiY29udHJhY3RDb2RlIjoiUmVWeHpBdGJGN0U9IiwiYWdlbmN5Q29kZSI6IkwreUgweThwOFlnPSIsInVzZXJJZCI6InFCTks1SVhRZ0dVPSIsInByb2ZpbGUiOiJSZVZ4ekF0YkY3RT0iLCJqdGkiOiIxNjU4NjZmZS1lYjZhLTRjYTItYjEyNS05YTU4YjU0ZTJlZjYiLCJleHAiOjE2Nzg2MTU5NTgsImlzcyI6IkludGVlZ3JhIiwiYXVkIjoiYXBpLWNsaWVudCJ9.qEvFBMtD-zk9T3K214kaWGjU_EMDEZKB0YKBJLRlQ3w"
    );
  });
};

//salvar no mice
async function insertNewAccessListApi(access) {
  var method =
    "https://hall-gateway.inteegra.com.br/heatmap/api/event/traceability/heatmap/register";
  const token = await getToken();
  var _currentDateStr = await getDate();

  const accessList = [
    {
      applicationId: 2,
      actionId: 4,
      page: "Login/LandingPage",
      accessDate: _currentDateStr,
      ipAddress: "",
      loginId: access.id.toString(),
      login: access.email,
      note: "Login/LandingPage",
      objectDescription: "Login/LandingPage",
      objectTypeDescription: "Login/LandingPage",
      eventId: 83778,
    },
  ];

  return new Promise((resolve, reject) => {
    const options = {
      url: method,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      },
      data: accessList,
    };
    firebaseHealthMap(access); // remover
    axios(options)
      .then((res) => {
        if (res.data.success) {
          resolve({ ok: true });
        } else {
          reject(res.data.data);
        }
      })
      .catch((err) => {
        console.log("Erro insertNewAccessListApi", err);
        reject(err);
      });
  });
}

async function firebaseHealthMap(access) {
  var method = "https://hall-gateway.inteegra.com.br/firebase/HealthMap";
  const token = await getToken();
  var _currentDateStr = await getDate();
  const accessList = [
    {
      applicationId: 2,
      actionId: 4,
      page: "Login/LandingPage",
      accessDate: _currentDateStr,
      ipAddress: "",
      loginId: access.id.toString(),
      login: access.email,
      note: "Login/LandingPage",
      objectDescription: "Login/LandingPage",
      objectTypeDescription: "Login/LandingPage",
      eventId: 83778,
      scheduleId: "",
      configId: "",
      description: "",
    },
  ];

  return new Promise((resolve, reject) => {
    const options = {
      url: method,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      },
      data: accessList,
    };
    axios(options)
      .then((res) => {})
      .catch((err) => {
        console.log("Erro firebaseHealthMap", err);
        reject(err);
      });
  });
}

function getDate() {
  return new Promise((resolve, reject) => {
    const method =
      "https://hall-gateway.inteegra.com.br/hall/api/event/traceability/calendar";

    const options = {
      url: method,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(options)
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        console.log("Erro getDate", err);
        reject(err);
      });
  });
}

export { verifyLogin, insertNewAccessListApi };
